export const GET_VENDOR_LOCKER_LIST_REQUEST = 'GET_VENDOR_LOCKER_LIST_REQUEST';
export const GET_VENDOR_LOCKER_LIST_SUCCESS = 'GET_VENDOR_LOCKER_LIST_SUCCESS';
export const GET_VENDOR_LOCKER_LIST_FAILURE = 'GET_VENDOR_LOCKER_LIST_FAILURE';
export const RESET_VENDOR_LOCKER_LIST_STATE = 'RESET_VENDOR_LOCKER_LIST_STATE';
